import React from "react";
import Translate from "react-translate-component";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const AccountCreate = ({
  op,
  current,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    if (current === op[1].registrar) {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.reg_account"
      }), "\xA0", linkToAccount(op[1].name));
    } else {
      return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].name), "\xA0", /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.was_reg_account"
      }), "\xA0", linkToAccount(op[1].registrar));
    }
  } else {
    return /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.reg_account",
      keys: [{
        type: "account",
        value: op[1].registrar,
        arg: "registrar"
      }, {
        type: "account",
        value: op[1].name,
        arg: "new_account"
      }]
    });
  }
};